export const testimonials = [
  {
    body: 'Cygnet Call Centre has been an invaluable partner for Kohler, handling our customer support with professionalism and care. Their expertise in our industry has significantly improved our customer satisfaction rates.',
    company: 'Kohler',
  },
  {
    body: "We've been working with Cygnet for over a decade, and they consistently deliver high-quality service. Their ability to adapt to our changing needs in the IT sector has been crucial to our growth.",
    company: 'Logicalis',
  },
  {
    body: 'Cygnet Call Centre has transformed our customer service in the oil and gas industry. Their professional team consistently delivers exceptional results, even in our complex technical environment.',
    company: 'Perenco',
  },
  {
    body: 'The level of care and attention to detail provided by Cygnet is unmatched. They truly feel like an extension of our team, understanding the unique needs of the construction industry.',
    company: 'Blount Shutters',
  },
  {
    body: 'Cygnet has been a trusted partner in providing technical support for our telecommunications customers. Their skilled agents handle complex issues efficiently and effectively.',
    company: 'Enea',
  },
  {
    body: 'Working with Cygnet has allowed us to focus on our core IT services while knowing our customer interactions are in good hands. Their flexibility and responsiveness in the tech industry are unparalleled.',
    company: 'Servicetec',
  },
];
